// extracted by mini-css-extract-plugin
module.exports = {"root":"PackagesBreadcrumbs_root__27Kgb","breadcrumbLink":"PackagesBreadcrumbs_breadcrumbLink__3VSr0","statusTitle":"PackagesBreadcrumbs_statusTitle__3gf0f"};